export type LocationStatusKey = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7;

export type LocationStatusValue =
    | 'Inactive'
    | 'Partner'
    | 'Standard'
    | 'Listed'
    | 'Ecommerce + Telehealth'
    | 'Chemistree'
    | 'Telehealth Only (No Ecommerce)'
    | 'Ecommerce Only (No Telehealth)';

export type LocationStatusMap = {
    [key in LocationStatusKey]: LocationStatusValue;
};

export const LOCATION_STATUS_MAP: Readonly<LocationStatusMap> = {
    0: 'Inactive',
    1: 'Partner',
    2: 'Standard',
    3: 'Listed',
    4: 'Ecommerce + Telehealth',
    5: 'Chemistree',
    6: 'Telehealth Only (No Ecommerce)',
    7: 'Ecommerce Only (No Telehealth)'
};

export const LOCATION_STATUSES =
    Object.keys(LOCATION_STATUS_MAP).map((key) => ({
        key: Number(key) as LocationStatusKey,
        value: LOCATION_STATUS_MAP[Number(key)] as LocationStatusValue
    }));
